<script>
import appConfig from "@/app.config";
// import Layout from "@/layouts/main.vue";
// import GamesSwiper from '@/components/GamesSwiper.vue';
// import Testimonials from '@/components/testimonials/Testimonials.vue';
// import Recommendation from '@/components/recommendation/Recommendation.vue';
// import HelpSupport from "@/components/HelpSupport.vue";

export default {
  page: {
    title: "Privacy",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    // Layout,
    // HelpSupport,
    // GamesSwiper,
    // Testimonials,
    // Recommendation,
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      showLoadingScreen: true,
      lang: 'en',
    };
  },
  created() {
    // 获取浏览器默认语言
    console.log('this.$i18n.locale', this.$i18n.locale)
    const lang = window.navigator.language.substr(0, 2);
    if (lang === "de") {
      this.GLOBAL.routetrGo("privacy-de");
    }
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
  },
  mounted() {
    this.scrollToTop();
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.scrollToTop();
        this.showLoadingScreen = false;
      }
    };
    console.log(this.$t('rivacy.Softindex3'))

  },
  methods: {
    languageChanged(value) {
      console.log('languageChanged', value)
      if (value === "en") {
        window.document.title = "Dr. Panda Privacy";
      } else {
        window.document.title = "用户个人信息保护政策";
      }
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
    },
  },
};
</script>

<template>
  <div :class="$style.charactersHero" class="d-inline-block w-100 d-flex">
    <b-container>
      <div :class="$style.heroContent" class="d-flex align-items-center justify-content-center">
        <h1>{{ $t("privacy.title") }}</h1>
      </div>
      <div :class="$style.despContent">
        <div>
          <p class="pb-5" v-html="$t('privacy.Softindex1')"></p>
          <p class="pb-5" v-html="$t('privacy.Softindex2')"></p>
          <template v-for="n in 10">
            <p v-if="$i18n.locale === 'zh' &&
              $t(`privacy.Softindex${n + 2}`) !==
              `privacy.Softindex${n + 2}`
            " :key="n" class="pb-5" v-html="$t(`privacy.Softindex${n + 2}`)"></p>
          </template>
        </div>
      </div>
    </b-container>
  </div>
</template>

<style lang='scss' module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.charactersHero {
  padding: 120px 0 0;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.heroContent {
  margin: auto;
  padding: 85px 0 120px 0;
}

.despContent {
  a {
    color: $color-dark-gray;
  }

  span {
    font-family: $family-bold;
  }

  ul {
    padding-left: 1.5rem !important;
  }
}

@media only screen and (max-width: 767px) {
  .heroContent {
    padding: 33px 0 125px 0;
    text-align: center;
  }

  .rightContent {
    img {
      width: 233px;
      height: auto;
    }
  }

  .leftContent {
    h2 {
      font-size: 32px;
    }

    img {
      padding-bottom: 30px;
    }
  }
}
</style>
